import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
const snapshot = () => open;
function setOpen(value: boolean) {
  if (open === value) return;
  open = value;
  for (const listener of listeners) listener();
}
export const closeActivityMenu = () => setOpen(false);
const toggle = () => setOpen(!open);

export function useActivityMenu() {
  return {
    open: useSyncExternalStore(subscribe, snapshot),
    toggle,
    close: closeActivityMenu,
  };
}
